var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuyers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 6)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#71E3E2",
    strokeWidth: 5,
    d: "M38.398 52.556L71.657 4.164a4.435 4.435 0 0 1 6.187-1.094l25.475 17.886a4.462 4.462 0 0 1 1.091 6.203L68.735 78.245a4.435 4.435 0 0 1-6.188 1.094l-7.448-5.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#71E3E2",
    strokeWidth: 5,
    d: "M22 88c12.487-1.626 21.065-3.773 25.736-6.44 4.67-2.669 11.648-11.061 20.931-25.178 3.11-4.676 3.11-8.334 0-10.974-3.11-2.641-7.319-1.566-12.627 3.224l-9.54 7.75-8.173-5.936M14.143 63.592l4.052-1.274 13.55-21.132c1.5-2.347 2.773-3.93 3.82-4.75 1.048-.82 6.916-2.743 17.606-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#71E3E2",
    strokeWidth: 5,
    d: "M4.752 62.005l5.123-1.473a4 4 0 0 1 4.952 2.744l7.597 26.564a4 4 0 0 1-2.741 4.944l-5.123 1.473a4 4 0 0 1-4.951-2.744L2.012 66.949a4 4 0 0 1 2.74-4.944z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 22,
    r: 3,
    fill: "#71E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#71E3E2",
    strokeWidth: 5,
    d: "M70.032 53.42c5.686 1.352 11.273-.14 14.203-4.336 4.147-5.938 1.398-15.041-6.139-20.333-7.537-5.291-17.009-4.767-21.156 1.17-3.067 4.394-2.361 10.52 1.267 15.552"
  }))));
}

export default SvgBuyers;